/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS0Icon20Solid = forwardRef('MediaAudioVolumeS0Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m4.632 6 4.301-3.715c.81-.7 2.067-.124 2.067.946V16.77c0 1.07-1.257 1.645-2.067.946L4.632 14H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2.632Z" })));
});
